import { useEffect, useState } from 'react';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import { ref, getDownloadURL } from 'firebase/storage';
import noPicture from './Editor/images/no_picture.jpg';

const Restaurant = (props) => {
    const [resFront, setFront] = useState("");
    const [resLogo, setLogo] = useState("");

    const remove = (e) => {
        e.stopPropagation();
        props.callback.remove(props.id, props.data);
    }

    const edit =(e) => {
        e.stopPropagation();
        props.callback.edit(props.id, props.data);
    }

    const open = () => {
        if(!props.preview){
            props.callback.open(props.id, props.data);
        }
    }

    useEffect(() => {
        // Get Current Front
        const frontRef = ref(props.storage, `Restaurants/${props.id}/${props.data.frontPic}`);
        
        getDownloadURL(frontRef).then((url) => {
            setFront(url);
        }).catch((error) => {
            console.log("Unable to get the photoURL");
        });

        //Get Current Logo
        const logoRef = ref(props.storage, `Restaurants/${props.id}/${props.data.logo}`);
        
        getDownloadURL(logoRef).then((url) => {
            setLogo(url);
        }).catch((error) => {
            console.log("Unable to get the photoURL");
        });        
    }, [props.data, props.id, props.storage]);
    
    return (
        <div className="Restaurant" onClick={(e) => open()}>
            <div style={{display: props.preview ? 'none':'flex'}} className='EditTools'>
                <button onClick={(e) => {edit(e); props.router(`Edit/${props.id}`)}} className="cbtn"><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                <button onClick={(e) => remove(e)} className="cbtn ml-1"><MdDelete size='1rem' pointerEvents='none' /></button>
            </div>

            <div style={{overflow: 'hidden', textAlign: 'center', maxHeight: '200px'}} >
                <img src={resFront?resFront:noPicture} width='100%' alt='Principal'/>
            </div>

            <div className="Info bg-white">
                <div><img className="Logo" src={resLogo?resLogo:noPicture} alt='logo' /></div>
                <div className="pl-1">
                    <div className="Name"><strong>{props.data.name}</strong></div>
                    <div className="Legend">{ props.data.legend.length > 21 ? props.data.legend.substring(0,20)+'...':props.data.legend}</div>
                </div>
            </div>            
        </div>
    );
}

export default Restaurant;